import { useRef } from 'react';
import XTable from 'components/XTable';
import { DatePicker, Select } from 'antd';
import { getIdenStatics } from 'api/checkInRecord';
import moment from 'moment';
import { applyTypes } from 'enumeration/applyTypes';
const { Option } = Select;
const CheckIdenStatistics = () => {
    const xTableRef = useRef();

    const queryItems = [
        {
            formItemApis: {
                label: '查询日期',
                help: null,
                name: 'visitDateRange',
            },
            item: <DatePicker format="YYYY-MM-DD" />,
        },
        {
            formItemApis: {
                label: '入住类别',
                help: null,
                name: 'applyType',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {applyTypes.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
    ];

    const columns = [
        {
            title: '申请年龄段',
            dataIndex: 'ageGroup',
        },
        {
            title: '性别',
            dataIndex: 'sex',
            children: [
                {
                    title: '公费',
                    dataIndex: 'freePay',
                    key: 'freePay',
                    children: [
                        {
                            title: '男',
                            dataIndex: 'femaleFreePay',
                            key: 'femaleFreePay',
                        },
                        {
                            title: '女',
                            dataIndex: 'maleFreePay',
                            key: 'maleFreePay',
                        },
                    ],
                },
                {
                    title: '自费',
                    dataIndex: 'selfPay',
                    key: 'selfPay',
                    children: [
                        {
                            title: '男',
                            dataIndex: 'femaleSelfPay',
                            key: 'femaleSelfPay',
                        },
                        {
                            title: '女',
                            dataIndex: 'maleSelfPay',
                            key: 'maleSelfPay',
                        },
                    ],
                },
            ],
        },
        {
            title: '护理区域',
            dataIndex: 'nursing_area',
            children: [
                {
                    title: '公费',
                    dataIndex: 'freePay',
                    key: 'freePay',
                    children: [
                        {
                            title: '自理区',
                            dataIndex: 'selfFreePay',
                            key: 'selfFreePay',
                        },
                        {
                            title: '半自理',
                            dataIndex: 'halfFreePay',
                            key: 'halfFreePay',
                        },
                        {
                            title: '全护理',
                            dataIndex: 'fullFreePay',
                            key: 'fullFreePay',
                        },
                    ],
                },
                {
                    title: '自费',
                    dataIndex: 'selfPay',
                    key: 'selfPay',
                    children: [
                        {
                            title: '自理区',
                            dataIndex: 'selfSelfPay',
                            key: 'selfSelfPay',
                        },
                        {
                            title: '半自理',
                            dataIndex: 'halfSelfPay',
                            key: 'halfSelfPay',
                        },
                        {
                            title: '全护理',
                            dataIndex: 'fullSelfPay',
                            key: 'fullSelfPay',
                        },
                    ],
                },
            ],
        },
        {
            title: '在院人数',
            dataIndex: 'checkIn',
        },
    ];

    const actionBtns = [];

    const handelParams = params => {
        const { visitDateRange, ...otherParams } = params;
        console.log(visitDateRange);
        let beginDate = '';
        let newParams = otherParams;
        // if (visitDateRange && visitDateRange.length) {
        beginDate = moment(visitDateRange).format('YYYY-MM-DD');
        // endDate = moment(visitDateRange[1]).format('YYYY-MM-DD');
        newParams = { ...otherParams, beginDate };
        // }
        return newParams;
    };

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                handelParams={handelParams}
                api={getIdenStatics}
                apiParams={{ status: true }}
                actionBtns={actionBtns}
                pagination={false}
                ref={xTableRef}
            />
        </div>
    );
};
export default CheckIdenStatistics;
